type TFunc = (key: string) => string

export function getOfficialExampleHtml(t: TFunc): string {
  return `<html-box>
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${t('example_html_card_title')}</title>
    <style>
        * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            font-family: "Garamond", "Times New Roman", serif;
        }
        
        body {
            background: #f2e9d8;
            background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%238b6e46' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E");
            padding: 20px 10px;
        }
        
        /* ${t('example_comment_core_card')} */
        .card {
            width: 95%; /* ${t('example_comment_95_width')} */
            max-width: 400px; /* ${t('example_comment_max_width')} */
            margin: 0 auto;
            /* === ${t('example_comment_bg_color_start')} === */
            background: #f8f0e0;
            /* === ${t('example_comment_bg_color_end')} === */
            background-image: 
                url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAMAAAAp4XiDAAAAUVBMVEWFhYWDg4N3d3dtbW17e3t1dXWBgYGHh4d5eXlzc3OLi4ubm5uVlZWPj4+NjY19fX2JiYl/f39ra2uRkZGZmZlpaWmXl5dvb29xcXGTk5NnZ2c8AAAAG3RSTlNAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEAvEOwtAAAFVklEQVR4XpWWB67c2BUFb3g557T/hRo9/WUMZHlgr4Bg8Z4qQgQJlHI4A8SzFVrapvmTF9O7dmYRFZ60YiBhJRCgh1FYhiLAmdvX0CzTOpNE77ME0Zty/nWWzchDtiqrmQDeuv3powQ5ta2eN0FY0InkqDD73lT9c9lEzwUNqgFHs9VQce3TVClFCQrSTfOiYkVJQBmpbq2L6iZavPnAPcoU0dSw0SUTqz/GtrGuXfbyyBniKykOWQWGqwwMA7QiYAxi+IlPdqo+hYHnUt5ZPfnsHJyNiDtnpJyayNBkF6cWoYGAMY92U2hXHF/C1M8uP/ZtYdiuj26UdAdQQSXQErwSOMzt/XWRWAz5GuSBIkwG1H3FabJ2OsUOUhGC6tK4EMtJO0ttC6IBD3kM0ve0tJwMdSfjZo+EEISaeTr9P3wYrGjXqyC1krcKdhMpxEnt5JetoulscpyzhXN5FRpuPHvbeQaKxFAEB6EN+cYN6xD7RYGpXpNndMmZgM5Dcs3YSNFDHUo2LGfZuukSWyUYirJAdYbF3MfqEKmjM+I2EfhA94iG3L7uKrR+GdWD73ydlIB+6hgref1QTlmgmbM3/LeX5GI1Ux1RWpgxpLuZ2+I+IjzZ8wqE4nilvQdkUdfhzI5QDWy+kw5Wgg2pGpeEVeCCA7b85BO3F9DzxB3cdqvBzWcmzbyMiqhzuYqtHRVG2y4x+KOlnyqla8AoWWpuBoYRxzXrfKuILl6SfiWCbjxoZJUaCBj1CjH7GIaDbc9kqBY3W/Rgjda1iqQcOJu2WW+76pZC9QG7M00dffe9hNnseupFL53r8F7YHSwJWUKP2q+k7RdsxyOB11n0xtOvnW4irMMFNV4H0uqwS5ExsmP9AxbDTc9JwgneAT5vTiUSm1E7BSflSt3bfa1tv8Di3R8n3Af7MNWzs49hmauE2wP+ttrq+AsWpFG2awvsuOqbipWHgtuvuaAE+A1Z/7gC9hesnr+7wqCwG8c5yAg3AL1fm8T9AZtp/bbJGwl1pNrE7RuOX7PeMRUERVaPpEs+yqeoSmuOlokqw49pgomjLeh7icHNlG19yjs6XXOMedYm5xH2YxpV2tc0Ro2jJfxC50ApuxGob7lMsxfTbeUv07TyYxpeLucEH1gNd4IKH2LAg5TdVhlCafZvpskfncCfx8pOhJzd76bJWeYFnFciwcYfubRc12Ip/ppIhA1/mSZ/RxjFDrJC5xifFjJpY2Xl5zXdguFqYyTR1zSp1Y9p+tktDYYSNflcxI0iyO4TPBdlRcpeqjK/piF5bklq77VSEaA+z8qmJTFzIWiitbnzR794USKBUaT0NTEsVjZqLaFVqJoPN9ODG70IPbfBHKK+/q/AWR0tJzYHRULOa4MP+W/HfGadZUbfw177G2j8R8+lIlydZX9g5ejfE6Zh9qAKed4RwiVgaJQFIOE3NBJqFeoG8qCDGwwIBK95q7NQDwuNu5y99v7DrYfZP7Rh7EgF4zvM3VQ+uUyrNAtuZHVGkF5S5f+c5F3yQx98Nz8kML0CkYV24ATQvVkf8f8AAAAASUVORK5CYII="),
                linear-gradient(to bottom, rgba(242, 217, 170, 0.4) 0%, rgba(248, 240, 224, 0) 20%, rgba(248, 240, 224, 0) 80%, rgba(242, 217, 170, 0.4) 100%);
            border-radius: 24px;
            /* === ${t('example_comment_border_color_start')} === */
            border: 3px solid #946b44;
            /* === ${t('example_comment_border_color_end')} === */
            box-shadow: 
                0 8px 20px rgba(0,0,0,0.15),
                inset 0 0 0 2px #f9f1e2,
                inset 0 0 40px rgba(242, 217, 170, 0.15);
            overflow: hidden;
            position: relative;
            padding-bottom: 20px;
        }
        
        /* ${t('example_comment_paper_wear')} */
        .card::before {
            content: "";
            position: absolute;
            top: 12%;
            left: 8%;
            width: 25px;
            height: 25px;
            background: rgba(220, 180, 100, 0.25);
            border-radius: 50%;
            filter: blur(10px);
            z-index: 1;
            opacity: 0.7;
        }
        
        .card::after {
            content: "";
            position: absolute;
            bottom: 18%;
            right: 10%;
            width: 35px;
            height: 35px;
            background: rgba(220, 180, 100, 0.18);
            border-radius: 50%;
            filter: blur(12px);
            z-index: 1;
            opacity: 0.7;
        }
        
        /* ${t('example_comment_avatar_frame')} */
        .image-frame {
            width: 90%;
            max-width: 320px;
            height: 400px;
            margin: 15px auto 12px;
            border-radius: 16px;
            border: 7px solid #946b44;
            box-shadow:
                0 6px 15px rgba(0,0,0,0.18),
                inset 0 0 0 3px #f8f0e0,
                inset 0 0 20px rgba(0,0,0,0.08);
            overflow: hidden;
            position: relative;
            background-image: url("https://img.tipsy.chat/user/coding/1772535240627444645_1776237675477355735.png");
            background-size: cover;
            background-position: center top;
            filter: sepia(18%) contrast(105%) brightness(88%) hue-rotate(-8deg) saturate(95%);
        }
        
        .image-frame::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: linear-gradient(
                to bottom, 
                rgba(242, 217, 170, 0.25) 0%, 
                rgba(242, 217, 170, 0) 15%, 
                rgba(242, 217, 170, 0) 85%, 
                rgba(242, 217, 170, 0.25) 100%
            ),
            linear-gradient(
                to right, 
                rgba(242, 217, 170, 0.25) 0%, 
                rgba(242, 217, 170, 0) 15%, 
                rgba(242, 217, 170, 0) 85%, 
                rgba(242, 217, 170, 0.25) 100%
            );
            pointer-events: none;
            z-index: 2;
        }
        
        /* ${t('example_comment_portrait')} */
        .portrait {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: sepia(18%) contrast(105%) brightness(88%) hue-rotate(-8deg) saturate(95%);
        }
        
        /* ${t('example_comment_name_section')} */
        .name-section {
            text-align: center;
            margin-bottom: 12px;
            padding: 7px 8px;
            position: relative;
            z-index: 2;
            border: 2px solid #b98f63;
            border-radius: 16px;
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            background: rgba(255, 255, 255, 0.2);
        }
        
        .char-name {
            font-size: 22px;
            font-weight: bold;
            color: #5a3e2b;
            text-transform: uppercase;
            letter-spacing: 1px;
            margin-bottom: 4px;
            text-shadow: 0.5px 0.5px 1px rgba(0,0,0,0.1);
        }
        
        .char-title {
            font-size: 12px;
            color: #7a5438;
            font-style: italic;
            background: rgba(255, 255, 255, 0.3);
            padding: 2px 8px;
            border-radius: 10px;
            display: inline-block;
            border: 1px solid #d4b892;
        }
        
        /* ${t('example_comment_content_section')} */
        .card-content {
            padding: 0 15px 8px;
            position: relative;
            z-index: 2;
        }
        
        .collapse-section {
            margin-bottom: 12px;
            border-radius: 14px;
            background: #fff8ed;
            border: 2px solid #b98f63;
            box-shadow: 
                3px 3px 8px rgba(0,0,0,0.1),
                inset 0 0 0 2px #fff8ed,
                inset 0 0 10px rgba(242, 217, 170, 0.1);
            overflow: hidden;
        }
        
        .collapse-btn {
            width: 100%;
            padding: 10px 15px;
            background: #7a5438;
            background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h10v10H0V0zm2 2v6h6V2H2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E");
            color: #f8f0e0;
            border: none;
            border-bottom: 2px solid #5a3e2b;
            border-radius: 12px 12px 0 0;
            text-align: left;
            font-size: 13px;
            font-weight: bold;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        
        .collapse-btn::after {
            content: "+";
            font-size: 16px;
            font-weight: normal;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.2);
            border: 1px solid #f8f0e0;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .collapse-btn.active::after {
            content: "-";
        }
        
        .collapse-content {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.3s ease;
            padding: 0 15px;
        }
        
        .content-inner {
            padding: 10px 0;
            font-size: 12px;
            color: #2d2418;
            line-height: 1.6;
            background-image: url("data:image/svg+xml,%3Csvg width='10' height='10' viewBox='0 0 10 10' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h10v10H0V0zm1 1v8h8V1H1z' fill='%23000000' fill-opacity='0.02' fill-rule='evenodd'/%3E%3C/svg%3E");
            border-top: 1px dashed #d4b892;
        }
        
        .trait-list {
            list-style: none;
            margin: 7px 0 0 0;
        }
        
        .trait-list li {
            margin: 5px 0;
            padding-left: 20px;
            position: relative;
        }
        
        .trait-list li::before {
            content: "❖";
            color: #8b0000;
            font-size: 10px;
            position: absolute;
            left: 0;
            text-shadow: 0.5px 0.5px 0 rgba(0,0,0,0.1);
            border: 1px solid #8b0000;
            width: 14px;
            height: 14px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .trait-label {
            font-weight: 700;
            color: #5a3e2b;
            text-shadow: 0.3px 0.3px 0 rgba(0,0,0,0.08);
        }
        
        /* ${t('example_comment_footer')} */
        .card-footer {
            padding: 10px 15px;
            text-align: center;
            font-size: 10px;
            color: #7a5438;
            position: relative;
            z-index: 2;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 0 0 20px 20px;
            margin: 0 12px;
            border: 2px solid #b98f63;
            border-top: 3px solid #946b44;
            font-weight: 600;
        }
        
        /* ${t('example_comment_paper_fold')} */
        .paper-fold {
            display: none;
        }
    </style>
</head>
<body>
    <div class="card">
        <div class="paper-fold"></div>
        
        <div class="image-frame">
            <!-- Background image is set via CSS. -->
        </div>

        <div class="name-section">
            <div class="char-name">${t('example_html_char_name')}</div>
            <div class="char-title">${t('example_html_char_title')}</div>
        </div>

        <div class="card-content">
            <div class="collapse-section">
                <button class="collapse-btn">${t('example_html_basic_profile')}</button>
                <div class="collapse-content">
                    <div class="content-inner">
                        <p><span class="trait-label">${t('example_html_appearance_label')}</span> ${t('example_html_appearance_desc')}</p>
                        <p><span class="trait-label">${t('example_html_core_label')}</span> ${t('example_html_core_desc')}</p>
                    </div>
                </div>
            </div>

            <div class="collapse-section">
                <button class="collapse-btn">${t('example_html_personality_traits')}</button>
                <div class="collapse-content">
                    <div class="content-inner">
                        <ul class="trait-list">
                            <li><span class="trait-label">${t('example_html_kuudere_label')}</span> ${t('example_html_kuudere_desc')}</li>
                            <li><span class="trait-label">${t('example_html_covert_warmth_label')}</span> ${t('example_html_covert_warmth_desc')}</li>
                            <li><span class="trait-label">${t('example_html_duty_bound_label')}</span> ${t('example_html_duty_bound_desc')}</li>
                            <li><span class="trait-label">${t('example_html_loyal_label')}</span> ${t('example_html_loyal_desc')}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="collapse-section">
                <button class="collapse-btn">${t('example_html_secret_bond')}</button>
                <div class="collapse-content">
                    <div class="content-inner">
                        <p>${t('example_html_secret_bond_desc')}</p>
                    </div>
                </div>
            </div>

            <div class="collapse-section">
                <button class="collapse-btn">${t('example_html_royal_crisis')}</button>
                <div class="collapse-content">
                    <div class="content-inner">
                        <p>${t('example_html_royal_crisis_desc')}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-footer">
            ${t('example_html_footer')}
        </div>
    </div>

    <script>
        const btns = document.querySelectorAll('.collapse-btn');
        btns.forEach(btn => {
            btn.addEventListener('click', () => {
                btn.classList.toggle('active');
                const content = btn.nextElementSibling;
                content.style.maxHeight = content.style.maxHeight ? null : content.scrollHeight + "px";
            });
        });
        btns[0].click();
    </script>
</body>
</html></html-box>`
}
